export const INTENT_MODULE_RESOURCE_TYPE = "spacelift/module";

export const INTENT_PROJECT_SUCCESS_MESSAGES = {
  CREATED: "Intent Project created successfully",
  UPDATED: "Intent Project updated successfully",
  DELETED: "Intent Project deleted successfully",
  INTEGRATION_ATTACHED: "Integration attached successfully",
  INTEGRATION_DETACHED: "Integration detached successfully",
  UNLOCKED: "Project unlocked successfully",
} as const;

export const REFETCH_INTENT_PROJECT_AND_ATTACHABLE_INTEGRATIONS_QUERIES = [
  "GetIntentProject",
  "GetAttachableAwsIntegrationsForIntentProject",
  "GetIntentProjectIntegration",
];
